//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'
//import {VueAgile} from "vue-agile"

export default {

    name: 'ProfileReferences',

    mixins: [ProfileData],

    //components: { agile: VueAgile },

    props: {
        company: {
        },
        destination: {
        },
    },

    data() {
        return {
            agileOptions: {
                autoplay: false,
                dots: true,
                navButtons: true,
                slidesToShow: 1,

            }
        }
    },

    methods: {

    },

    computed: {

    }

}

